module.exports = __webpack_public_path__ + "img/chrome-settings.558d4e2e.svg";